// fork from RBMC, removed some functionality, see application.js
import logger from '../utils/rbata.logger';
import urlUtils from './rbata.urlService';

let personalizedData = undefined;

const personalizeService = {
    getLanguage() {
        return alphatauri.config.language;
    },
    getLanguageName() {
        return alphatauri.config.languageName;
    },
    getCountry() {
        return alphatauri.config.country;
    },
    getCountryName() {
        return alphatauri.config.countryName;
    },
    getCurrency() {
        return alphatauri.config.currencySymbol;
    },
    getEncodedContextPath() {
        return alphatauri.config.encodedContextPath;
    },
    getPersonalizedData() {
        if (!personalizedData) {
            logger.log('fetch personalized data from server');
            let deferred = $.Deferred();

            $.ajax({
                url:    `${urlUtils.getBaseUrl()}personalize`,
                method: 'GET',
                cache:  false
            }).then((data) => {
                // TODO: a lot, check application.js
                personalizedData = data;
                deferred.resolve(personalizedData);
            }, (jqXHR) => {
                logger.error(`${jqXHR.status} error in getPersonalizedData`);
                deferred.reject(jqXHR)
            });
            personalizedData = deferred.promise();
        }
        return $.when(personalizedData);
    },
    requestCountryChange(language, country) {
        return $.ajax({
            url:         urlUtils.getBaseUrl() + 'set-language-country/',
            method:      'POST',
            contentType: 'application/json',
            dataType:    'json',
            data:        JSON.stringify({
                language: language,
                country:  country
            }),
        })
    }
};

export default personalizeService;
